import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
// environment-status: Phase 3, Task 4 - entity-page card showing a NavOneQCoreEnvironment's live
// pending/provisioning/ready/failed status. See plugins/environment-status.
import environmentStatusPlugin from 'environment-status';
// product-portfolio: product/version/client pages. See plugins/product-portfolio.
import productPortfolioPlugin from 'product-portfolio';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { signInModule } from './modules/signIn';
import { brandingModule } from './modules/branding';
import { notFoundModule, catalogGuardModule } from './modules/notFound';
import { catalogKindsModule } from './modules/catalogKinds';
import { adminOnlyModules } from './modules/adminOnly';
import { identityModule } from './modules/identity';

export default createApp({
  features: [
    catalogPlugin,
    environmentStatusPlugin,
    productPortfolioPlugin,
    navModule,
    homeModule,
    signInModule,
    brandingModule,
    notFoundModule,
    catalogGuardModule,
    catalogKindsModule,
    ...adminOnlyModules,
    identityModule,
  ],
});
